import { render, staticRenderFns } from "./UsersRolesPermissions.vue?vue&type=template&id=192435da&scoped=true"
import script from "./UsersRolesPermissions.vue?vue&type=script&lang=js"
export * from "./UsersRolesPermissions.vue?vue&type=script&lang=js"
import style0 from "./UsersRolesPermissions.vue?vue&type=style&index=0&id=192435da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192435da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192435da')) {
      api.createRecord('192435da', component.options)
    } else {
      api.reload('192435da', component.options)
    }
    module.hot.accept("./UsersRolesPermissions.vue?vue&type=template&id=192435da&scoped=true", function () {
      api.rerender('192435da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/user/UsersRolesPermissions.vue"
export default component.exports